module.exports = __webpack_public_path__ + "img/arrow.510b6c81.svg";